import * as React from "react"
import axios from "axios"
import { useSyncedState } from "hooks"
import BroadcastChannel from "broadcast-channel"
import { useCookies } from "react-cookie"

const channel = new BroadcastChannel<string>("auth")

export const AuthContext = React.createContext(false)
export const AuthContextSetState = React.createContext<React.Dispatch<string>>(
	(_token: string) => {}
)

const oneDay = 86400
const AuthProvider: React.FC = ({ children }) => {
	const [cookies, setCookie, removeCookie] = useCookies([])
	const [authToken, setAuthToken] = useSyncedState<string>(
		channel,
		cookies.authToken || ""
	)

	React.useEffect(() => {
		removeCookie("authToken")
		delete axios.defaults.headers.common["Authorization"]

		if (authToken !== "") {
			axios.defaults.headers.common["Authorization"] = authToken
			setCookie("authToken", authToken, {
				path: "/",
				maxAge: oneDay * 7,
				sameSite: "lax",
			})
		}
	}, [authToken])

	return (
		<AuthContext.Provider value={authToken !== ""}>
			<AuthContextSetState.Provider value={setAuthToken}>
				{children}
			</AuthContextSetState.Provider>
		</AuthContext.Provider>
	)
}

export default AuthProvider
